import { Injectable } from '@angular/core';
import { LogLevel, OpenIdConfiguration, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class OidcConfigService {

  // Configuración para Azure
  getAzureConfig(): OpenIdConfiguration {
    return {
      configId: 'AZURE',
      authority: `https://login.microsoftonline.com/${environment.tenantId}/v2.0`,
      redirectUrl: window.location.origin,
      postLogoutRedirectUri: window.location.origin + '/login',
      clientId: environment.appId,
      scope: 'openid profile email offline_access user.read',
      responseType: 'code',
      silentRenew: true,
      maxIdTokenIatOffsetAllowedInSeconds: 600,
      issValidationOff: false,
      secureRoutes: ['http://localhost:4200/', 'http://localhost:8080/', 'http://localhost:8081/', 'http://localhost:8082/', environment.apiUrl],
      autoUserInfo: false,
      useRefreshToken: true,
      triggerAuthorizationResultEvent: false,
      unauthorizedRoute: '/unauthorized',
      historyCleanupOff: false,
      logLevel: LogLevel.Error,
      customParamsAuthRequest: {
        prompt: 'select_account' // Fuerza selector de cuenta, evita SSO silencioso con sesión cacheada
      }
    };
  }

  // Configuración para Okta
  getOktaConfig(): OpenIdConfiguration {
    return {
      configId: 'OKTA',
      authority: environment.oktaAuthority,
      redirectUrl: window.location.origin + '/home',
      postLogoutRedirectUri: window.location.origin + '/login',
      clientId: environment.oktaClientId,
      scope: environment.oktaScope + ' offline_access',
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      renewTimeBeforeTokenExpiresInSeconds: 300,
      maxIdTokenIatOffsetAllowedInSeconds: 600,
      issValidationOff: false,
      ignoreNonceAfterRefresh: true,
      secureRoutes: [environment.apiUrl],
      autoUserInfo: false,
      unauthorizedRoute: '/unauthorized',
      logLevel: LogLevel.Error,
      customParamsAuthRequest: {
        prompt: 'login' // Fuerza re-autenticación siempre (fase de pruebas en INT).
        // Para producción, valorar 'select_account' o quitarlo del todo para permitir SSO real.
      }
    };
  }
}

export const authFactory = (configService: OidcConfigService) =>
  new StsConfigStaticLoader([
    configService.getAzureConfig(),
    configService.getOktaConfig()
  ]);
